import React, { useState } from "react";
import Page from "../../components/Page";
import {
  Card,
  Container,
  Dialog,
  DialogContent,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import ConceptosTablaBanco from "../../sections/@catalogos/conceptosbancos/ConceptosTabla";
import AddBancoConceptosButtom from "../../sections/@catalogos/conceptosbancos/AddBancoConceptosButtom";
import MuiAlert from "@mui/material/Alert";
const ConceptosBanco = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorGraph, setErrorGraph] = useState({
    severity: "",
    mensaje: "",
  });
  const [bodyDialog, setBodyDialog] = useState("");
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };
  return (
    <>
      <Page title="Conceptos Bancarios">
        <Container maxWidth="xl">
          <AddBancoConceptosButtom
            setOpenDialog={setOpenDialog}
            setBodyDialog={setBodyDialog}
            setErrorGraph={setErrorGraph}
            setOpenSnackBar={setOpenSnackBar}
          />

          <Card>
            <ConceptosTablaBanco
              setOpenDialog={setOpenDialog}
              setBodyDialog={setBodyDialog}
              setErrorGraph={setErrorGraph}
              setOpenSnackBar={setOpenSnackBar}
            />
          </Card>
        </Container>
        <Dialog open={openDialog}>
          <DialogContent>{bodyDialog}</DialogContent>
        </Dialog>
        <Snackbar
          open={openSnackBar}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={errorGraph.severity}
            sx={{ width: "100%" }}
          >
            {errorGraph.mensaje}
          </Alert>
        </Snackbar>
      </Page>
    </>
  );
};

export default ConceptosBanco;
